import { createSelector, createSlice } from "@reduxjs/toolkit";
import { prepareBasicQuestionsForStore } from "utils/basicQuestionsTransform";
import { searchForNodeInTreeAndReplace } from "utils/helpers";

const initialState = [];

export const slice = createSlice({
	name: "basic-questions",
	initialState,
	reducers: {
		replace: (_state, { payload }) => [...(prepareBasicQuestionsForStore(payload || []) || [])],
		replacePrepared: (_state, { payload }) => [...(payload || [])],
		append: (state, { payload }) => [...state, ...payload],
		replaceQuestion: (state, { payload: { question, allowFindByIndex = false } }) => [
			...(searchForNodeInTreeAndReplace({ list: [...(state || [])], single: question, allowFindByIndex }) || []),
		],
		delete: () => initialState,
	},
});

const selectBasicQuestionsState = (state) => state?.basicQuestions || [];

export const basicQuestionsSelector = createSelector(
	[selectBasicQuestionsState],
	(basicQuestions) => basicQuestions
);

export const { actions, reducer } = slice;

export default reducer;
